<template>
    <div class="inline-button">
        <md-button
            v-if="!isReadOnlyUser"
            title="Complete this maintenance schedule"
            :class="useIcon ? 'md-success md-just-icon md-round' : `${className}`"
            @click.stop="handleCompleteSchedule"
        >
            <md-icon v-if="useIcon">task</md-icon>
            <span v-else>Complete</span>
        </md-button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateAssetLogModal from '@/pages/AssetTracking/ModalComponents/CreateAssetLogModal';

export default {
    name: 'CompleteMaintenanceScheduleButton',
    props: {
        className: {
            type: String,
            default: () => ''
        },
        useIcon: {
            type: Boolean,
            default: () => true
        },
        maintenanceData: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapGetters({
            isReadOnlyUser: 'user/isReadOnlyUser'
        })
    },
    methods: {
        handleCompleteSchedule() {
            this.$modal
                .show(CreateAssetLogModal, {
                    maintenanceData: this.maintenanceData
                })
                .then((response) => {
                    this.$emit('maintenanceCompleted', response);
                    this.$modal.hide();
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.inline-button {
    display: inline-block;
}
</style>
